import { withInstall, withNoopInstall } from '@bigin/utils'
import Timeline from './src/timeline'
import TimelineItem from './src/timeline-item.vue'

export const BTimeline = withInstall(Timeline, {
  TimelineItem,
})
export default BTimeline
export const BTimelineItem = withNoopInstall(TimelineItem)

export * from './src/timeline'
export * from './src/timeline-item'
